<div   fxLayout="column" id="descdialog">
  <div class="dialog-title">
    <span class="subtitle-1">Description</span>
    <button mat-icon-button
            mat-dialog-close
            class="close-dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <p class="small">{{serviceDescription}}</p>
  </div>
  
</div>
  
